import script from "./comicContent.vue?vue&type=script&setup=true&lang=js"
export * from "./comicContent.vue?vue&type=script&setup=true&lang=js"

import "./comicContent.vue?vue&type=style&index=0&id=31875a00&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31875a00"]])

export default __exports__